import { useState } from "react";
import type { ConfirmState } from "../components/ConfirmDialog";
import type { Account, Recurring } from "../types";

export interface OverlayState {
  accountDetail: Account | null;
  setAccountDetail: (account: Account | null) => void;
  statementAccount: Account | null;
  setStatementAccount: (account: Account | null) => void;
  profileMenu: boolean;
  setProfileMenu: (open: boolean) => void;
  confirm: ConfirmState | null;
  setConfirm: (confirm: ConfirmState | null) => void;
  iouFocus: string | null;
  setIouFocus: (id: string | null) => void;
  billFocus: string | null;
  setBillFocus: (id: string | null) => void;
  tripFocus: string | null;
  setTripFocus: (id: string | null) => void;
  goalFocus: string | null;
  setGoalFocus: (id: string | null) => void;
  payingBill: Recurring | null;
  setPayingBill: (bill: Recurring | null) => void;
  pendingDetail: string | null;
  setPendingDetail: (key: string | null) => void;
}

/**
 * Encapsulates the visibility and target entities for all root-shell overlays:
 * account detail sheets, card statement forms, profile menus, confirmation dialogs,
 * entity focus targets (IOUs, bills, trips), bill payment modals, and pending transaction sheets.
 */
export function useAppOverlays(): OverlayState {
  const [accountDetail, setAccountDetail] = useState<Account | null>(null);
  const [statementAccount, setStatementAccount] = useState<Account | null>(null);
  const [profileMenu, setProfileMenu] = useState(false);
  const [confirm, setConfirm] = useState<ConfirmState | null>(null);
  const [iouFocus, setIouFocus] = useState<string | null>(null);
  const [billFocus, setBillFocus] = useState<string | null>(null);
  const [tripFocus, setTripFocus] = useState<string | null>(null);
  const [goalFocus, setGoalFocus] = useState<string | null>(null);
  const [payingBill, setPayingBill] = useState<Recurring | null>(null);
  const [pendingDetail, setPendingDetail] = useState<string | null>(null);

  return {
    accountDetail,
    setAccountDetail,
    statementAccount,
    setStatementAccount,
    profileMenu,
    setProfileMenu,
    confirm,
    setConfirm,
    iouFocus,
    setIouFocus,
    billFocus,
    setBillFocus,
    tripFocus,
    setTripFocus,
    goalFocus,
    setGoalFocus,
    payingBill,
    setPayingBill,
    pendingDetail,
    setPendingDetail,
  };
}
